import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
    onJoin: (displayName: string) => void;
    loading: boolean;
    error: string | null;
};

export default function PatientJoinScreen({ onJoin, loading, error }: Props) {
    const { t } = useTranslation();
    const [displayName, setDisplayName] = useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmed = displayName.trim();
        if (!trimmed) return;
        onJoin(trimmed);
    };

    return (
        <div className="flex h-screen flex-col items-center justify-center gap-6 p-6 text-center">
            <img
                src="/images/logo/logo.png"
                alt="Alchely"
                className="h-8 dark:brightness-0 dark:invert"
            />
            <h1 className="text-xl font-semibold text-gray-800">
                {t("constellation.join.title")}
            </h1>
            <form onSubmit={handleSubmit} className="flex w-full max-w-sm flex-col gap-3">
                <input
                    type="text"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    placeholder={t("constellation.join.namePlaceholder")}
                    aria-label={t("constellation.join.namePlaceholder")}
                    maxLength={60}
                    className="w-full rounded-md border px-3 py-2 text-sm"
                    autoFocus
                />
                {error && (
                    <p role="alert" className="text-sm text-red-600">
                        {error}
                    </p>
                )}
                <button
                    type="submit"
                    disabled={loading || displayName.trim() === ""}
                    className="min-h-[44px] rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50"
                >
                    {t("constellation.join.joinButton")}
                </button>
            </form>
        </div>
    );
}
